import axios from "../plugins/parseAxios";
export class RecurringInvoiceAPI {
  static getRecurringInvoicesBetweenDateByMarket(marketId, startDate, endDate) {
    return axios.post("functions/getRecurringInvoicesBetweenDateByMarket", {
      marketId,
      startDate,
      endDate,
    });
  }
}
